export default function About() {
  return (
    <section id="about" className="py-32 bg-[#FBF9F3]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-16">
          <div>
            <p className="text-[#C9A961] text-lg mb-8 italic" style={{ fontFamily: 'Playfair Display, serif' }}>
              /About Us
            </p>
            <p className="text-sm text-gray-500 mb-12">• Established 2020</p>
          </div>

          <div>
            <p className="text-2xl text-[#4A3F3A] leading-relaxed mb-12 font-light" style={{ lineHeight: '1.9' }}>
              Alwaz Travel London, part of Nex Pro Travels Limited, specialises in hand-picked hotels and accommodations for families and groups. We focus on high-standard, culturally respectful, family-friendly stays, offering personalised travel support for European travellers who expect comfort, authenticity, and reliability.
            </p>

            <div className="mb-12">
              <h3 className="text-3xl font-bold text-[#1A1F2E] mb-6" style={{ fontFamily: 'Playfair Display, serif' }}>
                Our Vision & Mission
              </h3>
              <p className="text-lg text-gray-700 leading-relaxed mb-6">
                Our vision is to become the preferred travel platform for families and group travellers seeking high-quality stays in the Middle East.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed">
                Our mission is to deliver a seamless, trustworthy, culturally aware booking experience, connecting travellers with exceptional accommodations and personalised service — every time.
              </p>
            </div>

            <div className="flex items-center gap-4 mb-6">
              <div className="flex -space-x-3">
                <div className="w-14 h-14 rounded-full bg-gray-300 border-4 border-[#FBF9F3] overflow-hidden">
                  <img
                    src="https://public.readdy.ai/ai/img_res/9a8b9ae6778fa0f84a8019baf82f29fb.jpg"
                    alt="Advisor"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="w-14 h-14 rounded-full bg-gray-300 border-4 border-[#FBF9F3] overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=Professional%20Muslim%20travel%20advisor%20man%20with%20beard%20smiling%20confidently%2C%20business%20portrait%2C%20professional%20attire%2C%20friendly%20expression%2C%20sepia%20vintage%20filter%20tone%2C%20high%20quality%20headshot%2C%20cultural%20diversity%2C%20expert%20consultant&width=200&height=200&seq=advisor-man-002&orientation=squarish"
                    alt="Advisor"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="w-14 h-14 rounded-full bg-gray-300 border-4 border-[#FBF9F3] overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=Professional%20female%20travel%20advisor%20wearing%20modest%20business%20attire%20smiling%20warmly%2C%20business%20portrait%2C%20friendly%20and%20approachable%2C%20sepia%20vintage%20filter%20tone%2C%20high%20quality%20headshot%2C%20diverse%20team%20member%2C%20expert%20professional&width=200&height=200&seq=advisor-woman-003&orientation=squarish"
                    alt="Advisor"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="w-14 h-14 rounded-full bg-gray-300 border-4 border-[#FBF9F3] overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=Professional%20male%20travel%20advisor%20in%20business%20attire%20smiling%20confidently%2C%20business%20portrait%2C%20friendly%20expression%2C%20sepia%20vintage%20filter%20tone%2C%20high%20quality%20headshot%2C%20diverse%20professional%20team%2C%20expert%20consultant&width=200&height=200&seq=advisor-man-004&orientation=squarish"
                    alt="Advisor"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
              <p className="text-[#4A3F3A] font-medium">Expert advisors ready to assist</p>
            </div>

            <div className="grid grid-cols-3 gap-6 mt-12">
              <div>
                <div className="text-4xl font-bold text-[#C9A961] mb-2">1000+</div>
                <div className="text-sm text-gray-600">Happy Families Served</div>
              </div>
              <div>
                <div className="text-4xl font-bold text-[#C9A961] mb-2">50+</div>
                <div className="text-sm text-gray-600">Destinations Covered</div>
              </div>
              <div>
                <div className="text-4xl font-bold text-[#C9A961] mb-2">500+</div>
                <div className="text-sm text-gray-600">Partner Hotels</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
